  // Countdown to local midnight 
  function updateCountdown() {
    const digitsEl   = document.getElementById('countdownDigits'); // SR/legacy
    const fallbackEl = document.getElementById('countdown');       // container
    const barEl      = document.getElementById('countdownBarFill');// optional

    // Structured H/M/S spans (preferred)
    const hEl = document.getElementById('ubH') || document.getElementById('cd-h');
    const mEl = document.getElementById('ubM') || document.getElementById('cd-m');
    const sEl = document.getElementById('ubS') || document.getElementById('cd-s');

    if (!digitsEl && !fallbackEl && !(hEl && mEl && sEl)) return;

    const pad = n => n.toString().padStart(2, '0');
    const totalSecondsInDay = 24 * 60 * 60;
    const nextLocalMidnight = () => {
      const now = new Date();
      const t = new Date(now);
      t.setHours(24, 0, 0, 0);
      return t;
    };

    let timerId = null;

    function render() {
      const left = Math.max(0, Math.floor((nextLocalMidnight() - new Date()) / 1000));
      const h = Math.floor(left / 3600);
      const m = Math.floor((left % 3600) / 60);
      const s = left % 60;

      if (hEl && mEl && sEl) {
        hEl.textContent = pad(h);
        mEl.textContent = pad(m);
        sEl.textContent = pad(s);
      } else {
        const text = `${pad(h)}:${pad(m)}:${pad(s)}`;
        if (digitsEl) digitsEl.textContent = text;
        else if (fallbackEl) fallbackEl.textContent = text;
      }

      if (digitsEl) {
        digitsEl.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
        digitsEl.setAttribute('aria-label', `${h} hours ${m} minutes ${s} seconds remaining today`);
      }

      if (barEl) barEl.style.width = (left / totalSecondsInDay * 100) + '%';
    }

    function stop() { if (timerId) { clearTimeout(timerId); timerId = null; } }

    function startAligned() {
      stop();
      render();
      const delay = 1000 - (Date.now() % 1000);
      timerId = setTimeout(function loop() {
        render();
        timerId = setTimeout(loop, 1000);
      }, delay);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop(); else startAligned();
    }, { passive: true });

    startAligned();
  }

  //SINGLE SOURCE OF TRUTH: Urgency Ticker 
  (function initUrgencyTicker() {
    const track = document.getElementById('tickerTrack');
    if (!track) return;

    const wrapper = track.closest('.ticker') || track.parentElement;
    const prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Cache originals for clean rebuilds
    const originals = Array.from(track.children).map(n => n.cloneNode(true));

    function ensureFill() {
      track.innerHTML = '';
      originals.forEach(n => track.appendChild(n.cloneNode(true)));

      // Duplicate until >= 2x wrapper width for seamless loop
      let safety = 12;
      while (track.scrollWidth < (wrapper.clientWidth * 2) && safety-- > 0) {
        originals.forEach(node => track.appendChild(node.cloneNode(true)));
      }
    }

    function setSpeed() {
      const PX_PER_SEC = 60; // adjust to taste
      const contentWidth = track.scrollWidth / 2 || track.scrollWidth || 1000;
      const dur = contentWidth / PX_PER_SEC;
      track.style.animationDuration = `${dur}s`;
    }

    ensureFill();

    if (prefersReduce) {
      // Reduced motion: disable CSS animation, gentle scroll
      track.style.animation = 'none';
      let pos = 0;
      let tickId = null;
      const step = 0.6;
      const loop = () => {
        pos += step;
        const half = track.scrollWidth / 2;
        if (pos >= half) pos = 0;
        wrapper.scrollLeft = pos;
        tickId = setTimeout(loop, 16);
      };
      const start = () => { if (!tickId) loop(); };
      const stop  = () => { if (tickId) { clearTimeout(tickId); tickId = null; } };
      wrapper.addEventListener('mouseenter', stop);
      wrapper.addEventListener('mouseleave', start);
      wrapper.addEventListener('focusin', stop);
      wrapper.addEventListener('focusout', start);
      start();
    } else {
      // CSS animation path: compute duration dynamically
      setSpeed();
      let resizeTO;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTO);
        resizeTO = setTimeout(() => {
          ensureFill();
          setSpeed();
        }, 120);
      }, { passive: true });
    }

    requestAnimationFrame(() => { track.style.visibility = 'visible'; });
  })();

  // Smooth scrolling  
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Fade-in animations 
  const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
  const fadeInObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('fade-in'); });
  }, observerOptions);
  document.querySelectorAll('.value-item, .book-card, .pricing-card, .testimonial').forEach(el => fadeInObserver.observe(el));

  //Init single countdown 
  updateCountdown();

  // Carousel 
  document.addEventListener('DOMContentLoaded', () => {
    const track = document.getElementById('track'); // regular carousel
    if (!track) return;

    const children = Array.from(track.children);
    children.forEach(node => track.appendChild(node.cloneNode(true)));

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.style.animation = 'none';
      const wrapper = document.querySelector('.carousel-wrapper');
      let pos = 0;
      const step = 0.6;
      setInterval(() => {
        pos += step;
        if (pos >= track.scrollWidth / 2) pos = 0;
        wrapper.scrollLeft = pos;
      }, 16);
    }
    requestAnimationFrame(() => track.style.visibility = 'visible');
  });

  // Modal form
  const modal = document.getElementById("popupForm");
  const closeBtn = document.querySelector(".close-btn");
  const buttons = document.querySelectorAll(".book-btn");
  const formResponse = document.getElementById("formResponse");
  const form = document.getElementById("bookForm");
  let selectedBook = "";

  if (modal) { modal.classList.remove("show"); modal.removeAttribute("style"); }

  function openModal(book) {
    selectedBook = book || "";
    if (formResponse) formResponse.textContent = "";
    if (modal) { modal.classList.add("show"); modal.setAttribute("aria-hidden", "false"); }
  }
  function closeModal() {
    if (modal) { modal.classList.remove("show"); modal.setAttribute("aria-hidden", "true"); }
  }
  buttons.forEach(btn => btn.addEventListener("click", () => openModal(btn.getAttribute("data-book"))));
  if (closeBtn) ["click", "touchend"].forEach(evt => closeBtn.addEventListener(evt, closeModal));
  window.addEventListener("click", e => { if (e.target === modal) closeModal(); });

  const scriptURLBook = "https://script.google.com/macros/s/AKfycbzudyyuZu-em-VZwbsNW66fNEWVOT9y7ls1Gcg5hpdCMkcSntSDCzGXh4N_Mm_FuWvW/exec";
  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      
      // ✅ STEP 1: Create FormData FIRST
      const formData = new FormData(form);
      
      // ✅ STEP 2: Add testType (use 'ACT' for ACT page, 'SAT' for SAT page)
      formData.append('testType', 'ACT');
      
      // ✅ STEP 3: Add selected book
      formData.append("book", selectedBook);
      
      if (formResponse) { 
        formResponse.style.color = "blue"; 
        formResponse.textContent = "⏳ Submitting... Please wait."; 
      }
      
      try {
        const res = await fetch(scriptURLBook, { method: "POST", body: formData });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        if (formResponse) { 
          formResponse.style.color = "green"; 
          formResponse.textContent = "✅ Submitted! Check your email for the link."; 
        }
        form.reset();
        setTimeout(() => { closeModal(); selectedBook = ""; }, 1200);
      } catch (error) {
        if (formResponse) { 
          formResponse.style.color = "red"; 
          formResponse.textContent = "❌ Error, please try again."; 
        }
        console.error("Error!", error);
      }
    });
  }
  //Scroll-triggered animations: books 
  const faders = document.querySelectorAll(".fade-in-up");
  const appearOptions = { threshold: 0.2, rootMargin: "0px 0px -50px 0px" };
  const appearOnScroll = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => { if (!entry.isIntersecting) return; entry.target.classList.add("show"); observer.unobserve(entry.target); });
  }, appearOptions);
  faders.forEach(fader => appearOnScroll.observe(fader));

  //Scroll-triggered animations: text-image
  document.addEventListener("DOMContentLoaded", () => {
    const faders2 = document.querySelectorAll('.fade-in-left, .fade-in-right');
    const appearOnScroll2 = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); } });
    }, { threshold: 0.2 });
    faders2.forEach(f => appearOnScroll2.observe(f));
  });

  //Testimonials carousel      
  document.addEventListener('DOMContentLoaded', () => {
    const tsTrack = document.getElementById('ts-track');
    if (!tsTrack) return;

    const wrapper = tsTrack.closest('.ts-carousel-wrapper');
    const viewport = wrapper?.querySelector('.ts-carousel-viewport');
    
    // Get all cards (first 8 are unique, rest are duplicates)
    const allCards = Array.from(tsTrack.children);
    const uniqueCount = 8;
    const slides = allCards.slice(0, uniqueCount);
    
    // Hide duplicate cards
    for (let i = uniqueCount; i < allCards.length; i++) {
      allCards[i].style.display = 'none';
    }
    
    // Create controls
    const controls = document.createElement('div');
    controls.className = 'ts-controls';
    controls.setAttribute('aria-label', 'Testimonial controls');
    
    const prevBtn = document.createElement('button');
    prevBtn.className = 'ts-btn ts-prev';
    prevBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Previous');
    prevBtn.textContent = '‹';
    
    const dots = document.createElement('div');
    dots.className = 'ts-dots';
    dots.setAttribute('role', 'tablist');
    
    const nextBtn = document.createElement('button');
    nextBtn.className = 'ts-btn ts-next';
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Next');
    nextBtn.textContent = '›';
    
    controls.appendChild(prevBtn);
    controls.appendChild(dots);
    controls.appendChild(nextBtn);
    wrapper.appendChild(controls);
    
    // Create dots
    for (let i = 0; i < slides.length; i++) {
      const dot = document.createElement('button');
      dot.className = 'ts-dot';
      dot.type = 'button';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dots.appendChild(dot);
    }
    
    let index = 0;
    let isAnimating = false;
    let autoTimer = null;
    
    function getSlideWidth() {
      const card = slides[0];
      if (!card) return 0;
      
      const cardRect = card.getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(tsTrack).gap) || 22;
      
      return cardRect.width + gap;
    }
    
    function updateDots() {
      const allDots = Array.from(dots.querySelectorAll('.ts-dot'));
      allDots.forEach((d, i) => {
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
    
    function updateButtons() {
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index === slides.length - 1;
    }
    
    function goTo(i, userInitiated = false) {
      if (isAnimating) return;
      
      // Clamp index
      index = Math.max(0, Math.min(i, slides.length - 1));
      isAnimating = true;
      
      const offset = getSlideWidth() * index;
      tsTrack.style.transform = `translateX(-${offset}px)`;
      
      updateDots();
      updateButtons();
      
      setTimeout(() => { isAnimating = false; }, 550);
      
      if (userInitiated) restartAuto();
    }
    
    function next() { 
      if (index < slides.length - 1) {
        goTo(index + 1, true); 
      }
    }
    
    function prev() { 
      if (index > 0) {
        goTo(index - 1, true); 
      }
    }
    
    function startAuto() {
      stopAuto();
      autoTimer = setInterval(() => {
        if (index >= slides.length - 1) {
          goTo(0, false);
        } else {
          goTo(index + 1, false);
        }
      }, 5000);
    }
    
    function stopAuto() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }
    
    function restartAuto() {
      stopAuto();
      startAuto();
    }
    
    // Button handlers
    prevBtn.onclick = prev;
    nextBtn.onclick = next;
    
    // Dot handlers
    Array.from(dots.querySelectorAll('.ts-dot')).forEach((dot, i) => {
      dot.onclick = () => goTo(i, true);
    });
    
    // Pause on hover
    wrapper.addEventListener('mouseenter', stopAuto);
    wrapper.addEventListener('mouseleave', startAuto);
    
    // Touch swipe
    let startX = 0, currentX = 0, touching = false;
    
    viewport.addEventListener('touchstart', (e) => {
      touching = true;
      startX = e.touches[0].clientX;
      currentX = startX;
      stopAuto();
    }, { passive: true });
    
    viewport.addEventListener('touchmove', (e) => {
      if (!touching) return;
      currentX = e.touches[0].clientX;
    }, { passive: true });
    
    viewport.addEventListener('touchend', () => {
      if (!touching) return;
      touching = false;
      
      const deltaX = currentX - startX;
      const threshold = 50;
      
      if (deltaX > threshold && index > 0) {
        prev();
      } else if (deltaX < -threshold && index < slides.length - 1) {
        next();
      } else {
        startAuto();
      }
    });
    
    // Handle resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        goTo(index, false);
      }, 150);
    });
    
    // Initialize
    goTo(0, false);
    startAuto();
    
    // Make visible
    requestAnimationFrame(() => {
      tsTrack.style.visibility = 'visible';
    });
  });

  // Floating Form 
  (function () {
    const root       = document.getElementById('vpCF');
    const closeBtn   = document.getElementById('vpCF-close');
    const toggleBtn  = document.getElementById('vpCF-toggle');
    const fab        = document.getElementById('vpCF-fab');
    const form       = document.getElementById('vpCF-form');
    const submitBtn  = document.getElementById('vpCF-submit');
    const toast      = document.getElementById('vpCF-toast');
    const multi      = document.querySelector('.vpCF-multi');
    const display    = document.getElementById('vpCF-multi-display');
    const options    = document.getElementById('vpCF-options');

    let success = document.getElementById('vpCF-success');
    if (!success && submitBtn && submitBtn.parentNode) {
      success = document.createElement('div');
      success.id = 'vpCF-success';
      success.className = 'vpCF-success';
      success.setAttribute('role', 'status');
      success.setAttribute('aria-live', 'polite');
      success.hidden = true;
      submitBtn.parentNode.insertBefore(success, submitBtn);
    }

    const formChildren = form ? Array.from(form.children) : [];
    let userToggled = false;
    let portaled = false;
    const isMobile = () => window.innerWidth <= 768;

    function showOnlySuccess(msg) {
      if (!form) return;
      form.reset();
      if (options) options.querySelectorAll('input[type="checkbox"]').forEach(i => (i.checked = false));
      if (display) display.textContent = 'Select books';
      if (options) options.classList.remove('active');
      closeOptionsPortal();
      formChildren.forEach(el => { el.style.display = 'none'; });
      success.textContent = msg || 'Thank you for submitting the form! Our team will reach out to you shortly.';
      success.hidden = false;
      success.style.display = 'block';
      success.classList.add('show');
    }
    function restoreFormUI() {
      formChildren.forEach(el => { el.style.removeProperty('display'); });
      success.classList.remove('show');
      success.hidden = true;
      success.style.display = 'none';
    }

    const setInitial = () => {
      if (!root) return;
      if (userToggled) {
        if (isMobile()) {
          toggleBtn && (toggleBtn.style.display = 'none');
          const isOpen = root.classList.contains('vpCF-visible') && !root.classList.contains('vpCF-hidden-desktop');
          fab && (fab.style.display = isOpen ? 'none' : 'flex');
        } else {
          fab && (fab.style.display = 'none');
          const isHidden = root.classList.contains('vpCF-hidden-desktop');
          toggleBtn && (toggleBtn.style.display = isHidden ? 'inline-flex' : 'none');
        }
        return;
      }
      if (isMobile()) {
        root.classList.remove('vpCF-visible');
        root.classList.add('vpCF-hidden-desktop');
        fab && (fab.style.display = 'flex');
        toggleBtn && (toggleBtn.style.display = 'none');
      } else {
        root.classList.remove('vpCF-hidden-desktop');
        fab && (fab.style.display = 'none');
        toggleBtn && (toggleBtn.style.display = 'none');
      }
    };

    const openForm = () => {
      userToggled = true;
      restoreFormUI();
      if (!root) return;
      if (isMobile()) {
        root.classList.add('vpCF-visible');
        root.classList.remove('vpCF-hidden-desktop');
        fab && (fab.style.display = 'none');
      } else {
        root.classList.remove('vpCF-hidden-desktop');
        toggleBtn && (toggleBtn.style.display = 'none');
      }
    };
    const closeForm = () => {
      userToggled = true;
      if (!root) return;
      if (isMobile()) {
        root.classList.remove('vpCF-visible');
        root.classList.add('vpCF-hidden-desktop');
        fab && (fab.style.display = 'flex');
      } else {
        root.classList.add('vpCF-hidden-desktop');
        toggleBtn && (toggleBtn.style.display = 'inline-flex');
      }
      closeOptionsPortal();
    };

    window.vpCF = window.vpCF || {};
    window.vpCF.open = openForm;
    window.vpCF.close = closeForm;

    function placeOptions() {
      if (!display || !options) return;
      const r = display.getBoundingClientRect();
      options.style.left = r.left + 'px';
      options.style.top  = (r.bottom + 6) + 'px';
      options.style.width = r.width + 'px';
    }
    function openOptionsPortal() {
      if (!options || !multi || portaled) return;
      document.body.appendChild(options);
      options.classList.add('portaled', 'active');
      placeOptions();
      portaled = true;
      window.addEventListener('resize', placeOptions);
      window.addEventListener('scroll', placeOptions, true);
    }
    function closeOptionsPortal() {
      if (!options || !multi || !portaled) return;
      multi.appendChild(options);
      options.classList.remove('portaled', 'active');
      options.removeAttribute('style');
      portaled = false;
      window.removeEventListener('resize', placeOptions);
      window.removeEventListener('scroll', placeOptions, true);
    }

    window.addEventListener('DOMContentLoaded', setInitial);
    window.addEventListener('resize', setInitial);
    closeBtn && closeBtn.addEventListener('click', closeForm);
    toggleBtn && toggleBtn.addEventListener('click', () => {
      if (!root) return;
      if (root.classList.contains('vpCF-hidden-desktop')) openForm(); else closeForm();
    });
    fab && fab.addEventListener('click', openForm);

    display && display.addEventListener('click', (e) => {
      e.stopPropagation();
      if (portaled) closeOptionsPortal(); else openOptionsPortal();
    });
    document.addEventListener('click', (e) => {
      const insideMulti = e.target.closest('.vpCF-multi');
      const insideOptions = options && options.contains(e.target);
      if (!insideMulti && portaled && !insideOptions) closeOptionsPortal();
    });

    if (options) {
      options.addEventListener('change', () => {
        const checked = Array.from(options.querySelectorAll('input[type="checkbox"]:checked')).map(i => i.value);
        if (display) display.textContent = checked.length
          ? (checked.length === 1 ? checked[0] : `${checked.length} books selected`)
          : 'Select books';
      });
    }

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('#pricing .btn-primary, .btn-primary, .cta-primary-1');
      if (!btn) return;
      e.preventDefault();
      if (window.vpCF && typeof window.vpCF.open === 'function') {
        window.vpCF.open();
        const first = document.querySelector('#vpCF input[name="name"]');
        if (first) first.focus({ preventScroll: true });
      } else {
        const widget = document.getElementById('vpCF');
        if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        if (options) {
          const checked = Array.from(options.querySelectorAll('input[type="checkbox"]:checked')).map(i => i.value);
          if (!checked.length) { alert('Please select at least one book'); return; }
        }

        const fd = new FormData(form);
        const checked = options ? Array.from(options.querySelectorAll('input[type="checkbox"]:checked')).map(i => i.value) : [];
        const data = {
          testType:      'ACT',
          name:         fd.get('name'),
          email:        fd.get('email'),
          phone:        fd.get('phone') || '',
          organization: fd.get('organization'),
          represent:    fd.get('represent'),
          students:     fd.get('students'),
          books:        checked.join(', '),
          startDate:    fd.get('startDate'),
          budget:       fd.get('budget'),
          timestamp:    new Date().toISOString()
        };

        if (submitBtn) { submitBtn.classList.add('loading'); submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }
        try {
          const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzudyyuZu-em-VZwbsNW66fNEWVOT9y7ls1Gcg5hpdCMkcSntSDCzGXh4N_Mm_FuWvW/exec';
          if (GOOGLE_SCRIPT_URL && GOOGLE_SCRIPT_URL.startsWith('http')) {
            const body = new URLSearchParams(data);
            await fetch(GOOGLE_SCRIPT_URL, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body });
          } else {
            await new Promise(r => setTimeout(r, 800));
          }

          if (isMobile()) {
            if (toast) { toast.style.display = 'block'; setTimeout(() => { toast.style.display = 'none'; }, 4000); }
            showOnlySuccess("Thanks! Your message has been sent. We'll get back to you shortly.");
            closeForm();
          } else {
            showOnlySuccess("Thanks! Your message has been sent. We'll get back to you shortly.");
          }
        } catch (err) {
          console.error(err);
          alert('There was an error submitting your form. Please try again.');
        } finally {
          if (submitBtn) { submitBtn.classList.remove('loading'); submitBtn.disabled = false; submitBtn.textContent = 'Submit'; }
        }
      });
    }

    const scrollTopBtn = document.getElementById('scrollTopBtn');
    if (scrollTopBtn) {
      window.addEventListener('scroll', () => {
        scrollTopBtn.style.display = (window.scrollY > 100) ? 'block' : 'none';
      }, { passive: true });
    }
    window.scrollToTop = function () { window.scrollTo({ top: 0, behavior: 'smooth' }); };
  })();

  // NEW: "THEY TRUST US" VIDEO CAROUSEL

  (function initTheyTrustUsCarousel() {
    const videoData = [
      {
        name: "ACT Math Practice Questions",
        price: "$27.99",
        icon: "https://cdn.shopify.com/s/files/1/0610/1837/4329/files/Act_Math_Practice_Questions_Paperbackandebook_Frontcover_V1.0.jpg?v=1762856946",
        url: "https://www.vibrantpublishers.com/products/act-math-practice-questions-prep-enhanced-act-2025-2026",
        video: "https://cdn.shopify.com/videos/c/o/v/3147b297f8cd460192979e76ee85b54b.mp4"
      },
      {
        name: "ACT Math Practice Questions",
        price: "$27.99",
        icon: "https://cdn.shopify.com/s/files/1/0610/1837/4329/files/Act_Math_Practice_Questions_Paperbackandebook_Frontcover_V1.0.jpg?v=1762856946",
        url: "https://www.vibrantpublishers.com/products/act-math-practice-questions-prep-enhanced-act-2025-2026",
        video: "https://cdn.shopify.com/videos/c/o/v/be9f32a8b19548d8bc953b113258dbb1.mp4"
      },
      {
        name: "Digital SAT Math Practice Questions",
        price: "$23.99",
        icon: "https://cdn.shopify.com/s/files/1/0610/1837/4329/files/DSAT_Math_Practice_Questions-amazon_FC.jpg?v=1758538581",
        url: "https://www.vibrantpublishers.com/products/digital-sat-math-practice-questions",
        video: "https://cdn.shopify.com/videos/c/o/v/4c1c6beb3a084042b90407c6ab80ef70.mp4"
      },
      {
        name: "Digital SAT Math Practice Questions",
        price: "$23.99",
        icon: "https://cdn.shopify.com/s/files/1/0610/1837/4329/files/DSAT_Math_Practice_Questions-amazon_FC.jpg?v=1758538581",
        url: "https://www.vibrantpublishers.com/products/digital-sat-math-practice-questions",
        video: "https://cdn.shopify.com/videos/c/o/v/2b02b662326a454ea8dfac7af987beac.mp4"
      },
      {
        name: "Digital SAT Math Practice Questions",
        price: "$23.99",
        icon: "https://cdn.shopify.com/s/files/1/0610/1837/4329/files/DSAT_Math_Practice_Questions-amazon_FC.jpg?v=1758538581",
        url: "https://www.vibrantpublishers.com/products/digital-sat-math-practice-questions",
        video: "https://cdn.shopify.com/videos/c/o/v/029565f7821d4ab58f28146940dca02b.mp4"
      },
      {
        name: "Digital SAT Math Practice Questions",
        price: "$23.99",
        icon: "https://cdn.shopify.com/s/files/1/0610/1837/4329/files/DSAT_Math_Practice_Questions-amazon_FC.jpg?v=1758538581",
        url: "https://www.vibrantpublishers.com/products/digital-sat-math-practice-questions",
        video: "https://cdn.shopify.com/videos/c/o/v/e7dc4c00b58d4522a36a892c62efece3.mp4"
      }
    ];

    let currentModalIndex = 0;
    let isScrolling = false;
    let scrollTimeout;

    // Auto-play videos on scroll with Intersection Observer
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target.querySelector('video');
        
        if (entry.isIntersecting) {
          video.play().catch(e => console.log('Autoplay prevented:', e));
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('.video-card').forEach(card => {
      videoObserver.observe(card);
    });

    // Carousel scroll function
    window.scrollCarousel = function(direction) {
      const carousel = document.getElementById('videoCarousel');
      if (!carousel) return;
      const scrollAmount = 300;
      carousel.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      });
    };

    // Touch/drag scrolling for carousel (mobile and desktop)
    let isDown = false;
    let startX;
    let scrollLeft;
    let startY;
    const carousel = document.getElementById('videoCarousel');

    if (carousel) {
      // Mouse events for desktop
      carousel.addEventListener('mousedown', (e) => {
        isDown = true;
        isScrolling = false;
        startX = e.pageX - carousel.offsetLeft;
        scrollLeft = carousel.scrollLeft;
      });

      carousel.addEventListener('mouseleave', () => {
        isDown = false;
      });

      carousel.addEventListener('mouseup', () => {
        isDown = false;
        // Delay to prevent click after drag
        setTimeout(() => {
          isScrolling = false;
        }, 100);
      });

      carousel.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        isScrolling = true;
        const x = e.pageX - carousel.offsetLeft;
        const walk = (x - startX) * 2;
        carousel.scrollLeft = scrollLeft - walk;
      });

      // Touch events for mobile
      carousel.addEventListener('touchstart', (e) => {
        isDown = true;
        isScrolling = false;
        startX = e.touches[0].pageX - carousel.offsetLeft;
        startY = e.touches[0].pageY;
        scrollLeft = carousel.scrollLeft;
      }, { passive: true });

      carousel.addEventListener('touchmove', (e) => {
        if (!isDown) return;
        
        const x = e.touches[0].pageX - carousel.offsetLeft;
        const y = e.touches[0].pageY;
        const walkX = Math.abs(x - startX);
        const walkY = Math.abs(y - startY);
        
        // Only scroll horizontally if horizontal movement is greater
        if (walkX > walkY) {
          isScrolling = true;
          const walk = (x - startX) * 2;
          carousel.scrollLeft = scrollLeft - walk;
        }
      }, { passive: true });

      carousel.addEventListener('touchend', () => {
        isDown = false;
        // Delay to prevent click after swipe
        setTimeout(() => {
          isScrolling = false;
        }, 100);
      }, { passive: true });

      // Click handler for video cards
      document.querySelectorAll('.video-card').forEach(card => {
        card.addEventListener('click', (e) => {
          if (!isScrolling) {
            const index = parseInt(card.getAttribute('data-index'));
            openVideoModal(index);
          }
        });
      });
    }

    // Open modal
    window.openVideoModal = function(index) {
      currentModalIndex = index;
      const modal = document.getElementById('videoModalOverlay');
      const modalCarousel = document.getElementById('videoModalCarousel');
      
      if (!modal || !modalCarousel) return;
      
      // Clear existing content
      modalCarousel.innerHTML = '';
      
      // Determine which videos to show (center, left, right)
      const totalVideos = videoData.length;
      const leftIndex = (index - 1 + totalVideos) % totalVideos;
      const rightIndex = (index + 1) % totalVideos;
      
      // Create array of videos to display
      const videosToShow = [
        { data: videoData[leftIndex], position: 'left', dataIndex: leftIndex },
        { data: videoData[index], position: 'center', dataIndex: index },
        { data: videoData[rightIndex], position: 'right', dataIndex: rightIndex }
      ];
      
      // Create video cards for modal
      videosToShow.forEach(({ data, position, dataIndex }) => {
        const card = document.createElement('div');
        card.className = 'video-modal-card';
        card.setAttribute('data-index', dataIndex);
        if (position === 'center') card.classList.add('center');
        
        card.innerHTML = `
          <video loop muted playsinline ${position === 'center' ? 'autoplay' : ''}>
            <source src="${data.video}" type="video/mp4">
          </video>
          <div class="video-overlay"></div>
          
          ${position === 'center' ? `
          <div class="video-modal-controls">
            <button class="video-modal-control-btn share-btn" onclick="shareVideo(event, '${data.url}', '${data.name}')">
              <svg viewBox="0 0 24 24">
                <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>
              </svg>
            </button>
            <button class="video-modal-control-btn mute-modal-btn" onclick="toggleVideoModalMute(event)">
              <svg class="unmuted" viewBox="0 0 24 24">
                <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
              </svg>
              <svg class="muted" style="display: none;" viewBox="0 0 24 24">
                <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
              </svg>
            </button>
            <button class="video-modal-control-btn pause-modal-btn" onclick="toggleVideoModalPlayPause(event)">
              <svg class="pause-icon" viewBox="0 0 24 24">
                <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
              </svg>
              <svg class="play-icon" style="display: none;" viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z"/>
              </svg>
            </button>
          </div>

          <div class="video-modal-product-badge" onclick="handleVideoProductClick('${data.url}')">
            <img src="${data.icon}" alt="${data.name}" class="video-modal-badge-icon">
            <div class="video-modal-badge-info">
              <div class="video-modal-badge-name">${data.name}</div>
              <div class="video-modal-badge-price">${data.price}</div>
            </div>
            <button class="video-modal-add-to-cart">Buy Now</button>
          </div>
          ` : ''}
        `;
        modalCarousel.appendChild(card);
      });
      
      // Show modal
      modal.classList.add('video-modal-active');
      document.body.style.overflow = 'hidden';
      
      // Initialize modal swipe after short delay
      setTimeout(initModalSwipe, 100);
    };

    // Close modal
    window.closeVideoModal = function() {
      const modal = document.getElementById('videoModalOverlay');
      if (!modal) return;
      
      modal.classList.remove('video-modal-active');
      document.body.style.overflow = '';
      
      // Stop all modal videos
      document.querySelectorAll('.video-modal-card video').forEach(video => {
        video.pause();
      });
      
      // Reset swipe initialization flag
      modalSwipeInitialized = false;
    };

    // Setup modal close handlers
    document.addEventListener('DOMContentLoaded', () => {
      const modal = document.getElementById('videoModalOverlay');
      const closeBtn = document.querySelector('.video-modal-close');
      
      // Close button click
      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          closeVideoModal();
        });
      }
      
      // Click outside modal to close
      if (modal) {
        modal.addEventListener('click', (e) => {
          // Only close if clicking on the overlay background, not the content
          if (e.target === modal || e.target.classList.contains('video-modal-content')) {
            closeVideoModal();
          }
        });
      }
      
      // Arrow button handlers
      const prevArrow = document.querySelector('.video-modal-nav-arrow.prev');
      const nextArrow = document.querySelector('.video-modal-nav-arrow.next');
      
      if (prevArrow) {
        prevArrow.addEventListener('click', () => navigateVideoModal(-1));
      }
      if (nextArrow) {
        nextArrow.addEventListener('click', () => navigateVideoModal(1));
      }
    });

    // Navigate modal
    window.navigateVideoModal = function(direction) {
      const totalVideos = videoData.length;
      currentModalIndex = (currentModalIndex + direction + totalVideos) % totalVideos;
      
      // Re-render the modal with new center video
      openVideoModal(currentModalIndex);
    };

    // Toggle modal mute
    window.toggleVideoModalMute = function(event) {
      event.stopPropagation();
      const centerCard = document.querySelector('.video-modal-card.center');
      if (!centerCard) return;
      
      const video = centerCard.querySelector('video');
      const btn = event.currentTarget;
      const unmutedIcon = btn.querySelector('.unmuted');
      const mutedIcon = btn.querySelector('.muted');
      
      video.muted = !video.muted;
      
      if (video.muted) {
        unmutedIcon.style.display = 'block';
        mutedIcon.style.display = 'none';
      } else {
        unmutedIcon.style.display = 'none';
        mutedIcon.style.display = 'block';
      }
    };

    // Toggle modal play/pause
    window.toggleVideoModalPlayPause = function(event) {
      event.stopPropagation();
      const centerCard = document.querySelector('.video-modal-card.center');
      if (!centerCard) return;
      
      const video = centerCard.querySelector('video');
      const btn = event.currentTarget;
      const playIcon = btn.querySelector('.play-icon');
      const pauseIcon = btn.querySelector('.pause-icon');
      
      if (video.paused) {
        video.play();
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
      } else {
        video.pause();
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
      }
    };

    // Share video function
    window.shareVideo = async function(event, productUrl, productName) {
      event.stopPropagation();
      
      const shareData = {
        title: productName,
        text: `Check out ${productName}!`,
        url: productUrl
      };

      try {
        // Check if Web Share API is available
        if (navigator.share) {
          await navigator.share(shareData);
          console.log('Shared successfully');
        } else {
          // Fallback: Copy to clipboard
          await navigator.clipboard.writeText(productUrl);
          
          // Show a temporary notification
          const notification = document.createElement('div');
          notification.textContent = 'Link copied to clipboard!';
          notification.style.cssText = `
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(0, 0, 0, 0.9);
            color: white;
            padding: 15px 30px;
            border-radius: 8px;
            font-size: 14px;
            z-index: 10002;
            animation: fadeInOut 2s ease-in-out;
          `;
          
          // Add animation
          const style = document.createElement('style');
          style.textContent = `
            @keyframes fadeInOut {
              0%, 100% { opacity: 0; }
              10%, 90% { opacity: 1; }
            }
          `;
          document.head.appendChild(style);
          
          document.body.appendChild(notification);
          
          setTimeout(() => {
            notification.remove();
            style.remove();
          }, 2000);
        }
      } catch (err) {
        console.log('Error sharing:', err);
      }
    };

    // Handle product click
    window.handleVideoProductClick = function(productUrl) {
      console.log('Navigating to product:', productUrl);
      // Redirect to the product URL
      window.open(productUrl, '_blank');
    };

    // Modal swipe functionality
    let modalStartX = 0;
    let modalStartY = 0;
    let modalIsDown = false;
    let modalIsScrolling = false;
    let modalSwipeInitialized = false;

    function initModalSwipe() {
      if (modalSwipeInitialized) return; // Prevent multiple initializations
      
      const modalContent = document.getElementById('videoModalCarousel');
      if (!modalContent) return;
      
      // Desktop drag for modal
      const handleModalMouseDown = (e) => {
        // Don't interfere with buttons and badges
        if (e.target.closest('.video-modal-product-badge') || e.target.closest('.video-modal-control-btn')) return;
        modalIsDown = true;
        modalIsScrolling = false;
        modalStartX = e.pageX;
        e.preventDefault();
      };

      const handleModalMouseUp = (e) => {
        if (modalIsDown) {
          const diffX = e.pageX - modalStartX;
          // Navigate if swipe is significant enough
          if (Math.abs(diffX) > 80 && !modalIsScrolling) {
            navigateVideoModal(diffX > 0 ? -1 : 1);
          }
        }
        modalIsDown = false;
        modalIsScrolling = false;
      };

      const handleModalMouseMove = (e) => {
        if (modalIsDown) {
          const diffX = Math.abs(e.pageX - modalStartX);
          if (diffX > 10) {
            modalIsScrolling = true;
          }
        }
      };

      // Mobile touch for modal
      const handleModalTouchStart = (e) => {
        // Don't interfere with buttons and badges
        if (e.target.closest('.video-modal-product-badge') || e.target.closest('.video-modal-control-btn')) return;
        modalStartX = e.touches[0].pageX;
        modalStartY = e.touches[0].pageY;
        modalIsScrolling = false;
      };

      const handleModalTouchEnd = (e) => {
        const diffX = e.changedTouches[0].pageX - modalStartX;
        const diffY = Math.abs(e.changedTouches[0].pageY - modalStartY);
        
        // Only navigate if horizontal swipe is greater than vertical and significant
        if (Math.abs(diffX) > 80 && Math.abs(diffX) > diffY * 1.5) {
          navigateVideoModal(diffX > 0 ? -1 : 1);
        }
      };

      // Add event listeners
      modalContent.addEventListener('mousedown', handleModalMouseDown);
      document.addEventListener('mouseup', handleModalMouseUp);
      document.addEventListener('mousemove', handleModalMouseMove);
      modalContent.addEventListener('touchstart', handleModalTouchStart, { passive: true });
      modalContent.addEventListener('touchend', handleModalTouchEnd, { passive: true });
      
      modalSwipeInitialized = true;
    }

    // Close modal on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const videoModal = document.getElementById('videoModalOverlay');
        if (videoModal && videoModal.classList.contains('video-modal-active')) {
          closeVideoModal();
        }
      }
    });

    // Arrow key navigation in modal
    document.addEventListener('keydown', (e) => {
      const modal = document.getElementById('videoModalOverlay');
      if (modal && modal.classList.contains('video-modal-active')) {
        if (e.key === 'ArrowLeft') navigateVideoModal(-1);
        if (e.key === 'ArrowRight') navigateVideoModal(1);
      }
    });
  })();